enum DescriptionDialogFields {
	TITLE = "title",
	AUTHOR = "author",
	SUBJECT = "subject",
	KEYWORDS = "keywords",
	PRODUCER = "producer",
	CREATOR = "creator",
	CUSTOM = "custom",
	KEY = "key",
	VALUE = "value"
}

export default DescriptionDialogFields;